/**
 * v4 PDP - carousel, pricing, facts zoom. Shopify Ajax cart on submit.
 */
(function () {
  const QUOTE_INTERVAL_MS = 5000;

  const section = document.querySelector(".v4-pdp");
  if (!section) return;

  const mainImgs = section.querySelectorAll(".v4-pdp__main-img[data-slide]");
  const SLIDE_COUNT =
    Number(section.dataset.slideCount) ||
    (mainImgs.length ? Math.max(...[...mainImgs].map((img) => Number(img.dataset.slide) + 1)) : 2);

  const PRICES = {
    subscribe: Number(section.dataset.priceSubscribe) || 0,
    "one-time": Number(section.dataset.priceOnetime) || 0,
  };
  const productTitle = section.dataset.productTitle || "this product";
  // Real Shopify subscription plan id for this product, if one is set up. Empty = none yet.
  const sellingPlanId = section.dataset.sellingPlanId || "";
  const sellingPlanInput = section.querySelector('input[name="selling_plan"]');

  let slide = 0;
  let purchase = "subscribe";
  let quoteIdx = 0;

  const mainStage = section.querySelector(".v4-pdp__main");
  const lightboxRoot = document.getElementById("v4-facts-lightbox-root");
  const thumbs = section.querySelectorAll(".v4-pdp__thumb");
  const quotes = section.querySelectorAll(".v4-pdp__trust-quote-item");
  const tiles = section.querySelectorAll(".v4-pdp__purchase-tile");
  const cta = document.getElementById("v4-add-to-cart");
  const stickyCta = document.getElementById("v4-pdp-sticky-cta");
  const form = document.getElementById("fb-v4-pdp-form");

  function getActiveImage() {
    return section.querySelector(".v4-pdp__main-img.--active");
  }

  function isZoomableSlide(index) {
    return index !== 0;
  }

  function updateZoomUi() {
    if (!mainStage) return;
    const zoomable = isZoomableSlide(slide);
    mainStage.classList.toggle("--zoomable", zoomable);
    const hint = mainStage.querySelector(".v4-pdp__main-zoom-hint");
    if (hint) hint.hidden = !zoomable;
  }

  function prepareMainGallery() {
    if (!mainStage) return;

    const zoomBtn = mainStage.querySelector(".v4-pdp__main-zoom");
    if (zoomBtn) {
      const zoomImg = zoomBtn.querySelector(".v4-pdp__main-img");
      const firstArrow = mainStage.querySelector(".v4-pdp__arrow");
      if (zoomImg) mainStage.insertBefore(zoomImg, firstArrow);
      zoomBtn.remove();
    }

    mainStage.querySelector(".v4-pdp__magnifier-lens")?.remove();

    if (!mainStage.querySelector(".v4-pdp__main-zoom-hint")) {
      const hint = document.createElement("span");
      hint.className = "v4-pdp__main-zoom-hint";
      hint.setAttribute("aria-hidden", "true");
      hint.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.6"/><line x1="11" y1="8" x2="11" y2="14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><line x1="8" y1="11" x2="14" y2="11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><line x1="16" y1="16" x2="21" y2="21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg> Click to zoom';
      const firstArrow = mainStage.querySelector(".v4-pdp__arrow");
      mainStage.insertBefore(hint, firstArrow);
    } else if (mainStage.querySelector(".v4-pdp__main-zoom-hint")?.textContent.includes("Hover to zoom")) {
      mainStage.querySelector(".v4-pdp__main-zoom-hint").innerHTML = mainStage
        .querySelector(".v4-pdp__main-zoom-hint")
        .innerHTML.replace("Hover to zoom", "Click to zoom");
    }
  }

  function closeLightbox() {
    if (!lightboxRoot || lightboxRoot.hidden) return;
    lightboxRoot.hidden = true;
    lightboxRoot.innerHTML = "";
    document.body.style.overflow = "";
    document.removeEventListener("keydown", closeLightboxOnEscape);
  }

  function closeLightboxOnEscape(event) {
    if (event.key === "Escape") closeLightbox();
  }

  function openLightbox() {
    const activeImg = getActiveImage();
    if (!activeImg?.src || !lightboxRoot || !isZoomableSlide(slide)) return;

    const url = activeImg.currentSrc || activeImg.src;
    const alt = (activeImg.alt || "Product image, zoomed").replace(/"/g, "&quot;");

    lightboxRoot.hidden = false;
    lightboxRoot.innerHTML = `
      <div class="v4-facts-lightbox" role="dialog" aria-modal="true" aria-label="Product image, zoomed">
        <button type="button" class="v4-facts-lightbox__close" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="v4-facts-lightbox__stage">
          <img src="${url}" alt="${alt}" class="v4-facts-lightbox__img" />
        </div>
      </div>`;

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", closeLightboxOnEscape);

    const box = lightboxRoot.querySelector(".v4-facts-lightbox");
    const stage = lightboxRoot.querySelector(".v4-facts-lightbox__stage");

    box?.addEventListener("click", (event) => {
      if (event.target === box) closeLightbox();
    });
    stage?.addEventListener("click", (event) => event.stopPropagation());
    lightboxRoot.querySelector(".v4-facts-lightbox__close")?.addEventListener("click", (event) => {
      event.stopPropagation();
      closeLightbox();
    });
  }

  function bindClickZoom() {
    if (!mainStage) return;
    mainStage.addEventListener("click", (event) => {
      if (event.target.closest(".v4-pdp__arrow")) return;
      if (!isZoomableSlide(slide)) return;
      openLightbox();
    });
  }

  function syncLightboxImage() {
    if (!lightboxRoot || lightboxRoot.hidden) return;
    if (!isZoomableSlide(slide)) {
      closeLightbox();
      return;
    }
    const activeImg = getActiveImage();
    const lbImg = lightboxRoot.querySelector(".v4-facts-lightbox__img");
    if (!activeImg || !lbImg) return;
    lbImg.src = activeImg.currentSrc || activeImg.src;
    lbImg.alt = activeImg.alt || "Product image, zoomed";
  }

  function setSlide(index) {
    slide = (index + SLIDE_COUNT) % SLIDE_COUNT;
    mainImgs.forEach((img) => {
      const i = Number(img.dataset.slide);
      const active = i === slide;
      img.classList.toggle("--active", active);
      if (img.tagName === "IMG") {
        const alt = img.dataset.altActive || img.getAttribute("data-default-alt") || img.alt;
        if (active && alt) img.alt = alt;
        img.setAttribute("aria-hidden", active ? "false" : "true");
      }
    });
    thumbs.forEach((btn) => {
      const i = Number(btn.dataset.slide);
      const active = i === slide;
      btn.classList.toggle("--active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
    syncLightboxImage();
    updateZoomUi();
  }

  function formatPrice(amount) {
    return amount.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function setPurchase(type) {
    purchase = type;
    tiles.forEach((tile) => {
      const on = tile.dataset.purchase === type;
      tile.classList.toggle("--active", on);
      tile.setAttribute("aria-checked", on ? "true" : "false");
    });
    // Attach the real subscription plan only when "Subscribe & Save" is chosen and a plan exists.
    if (sellingPlanInput) {
      if (type === "subscribe" && sellingPlanId) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = "";
        sellingPlanInput.disabled = true;
      }
    }
    const price = PRICES[type];
    if (cta && price) {
      const formatted = formatPrice(price);
      cta.textContent = `Add to Cart - ${formatted}`;
      cta.setAttribute("aria-label", `Add ${productTitle} to cart - ${formatted}`);
    }
    document.dispatchEvent(
      new CustomEvent("v4:purchase-changed", { detail: { type, price: PRICES[type] } }),
    );
  }

  function setQuote(index) {
    quoteIdx = (index + quotes.length) % quotes.length;
    quotes.forEach((q, i) => {
      const active = i === quoteIdx;
      q.classList.toggle("--active", active);
      q.setAttribute("aria-hidden", active ? "false" : "true");
    });
  }

  async function submitToShopifyCart(event) {
    event.preventDefault();
    if (!form || !cta) return;

    const formData = new FormData(form);
    cta.disabled = true;
    const prevLabel = cta.textContent;
    if (stickyCta) stickyCta.disabled = true;
    const prevStickyLabel = stickyCta?.textContent;

    try {
      const res = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : "/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || "Could not add to cart");

      document.dispatchEvent(new CustomEvent("v4:cart-updated"));
      if (window.V4ShopifyCart?.openDrawer) {
        window.V4ShopifyCart.openDrawer();
      }
      cta.textContent = "Added to cart ✓";
      if (stickyCta) stickyCta.textContent = "Added to cart ✓";
      window.setTimeout(() => setPurchase(purchase), 1400);
    } catch (err) {
      cta.textContent = "Try again";
      if (stickyCta) stickyCta.textContent = "Try again";
      window.setTimeout(() => {
        cta.textContent = prevLabel;
        if (stickyCta && prevStickyLabel) stickyCta.textContent = prevStickyLabel;
      }, 1400);
      console.error(err);
    } finally {
      cta.disabled = false;
      if (stickyCta) stickyCta.disabled = false;
    }
  }

  section.querySelector(".v4-pdp__arrow--prev")?.addEventListener("click", () => setSlide(slide - 1));
  section.querySelector(".v4-pdp__arrow--next")?.addEventListener("click", () => setSlide(slide + 1));
  thumbs.forEach((btn) => btn.addEventListener("click", () => setSlide(Number(btn.dataset.slide))));
  prepareMainGallery();
  updateZoomUi();
  bindClickZoom();
  tiles.forEach((tile) =>
    tile.addEventListener("click", () => setPurchase(tile.dataset.purchase || "subscribe")),
  );
  form?.addEventListener("submit", submitToShopifyCart);

  if (quotes.length > 1) {
    window.setInterval(() => setQuote(quoteIdx + 1), QUOTE_INTERVAL_MS);
  }

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const revealEls = document.querySelectorAll(".v4-reveal");
  if (reduce) {
    revealEls.forEach((el) => el.classList.add("--in"));
  } else {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("--in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" },
    );
    revealEls.forEach((el) => {
      if (!el.classList.contains("--in")) obs.observe(el);
    });
  }

  function resetCarouselForBuyAnchor() {
    setSlide(0);
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href="#buy"], a[href="#shop"]');
    if (link) resetCarouselForBuyAnchor();
  });

  window.addEventListener("hashchange", () => {
    const hash = window.location.hash;
    if (hash === "#buy" || hash === "#shop") resetCarouselForBuyAnchor();
  });

  mainImgs.forEach((img) => {
    if (img.alt) img.setAttribute("data-default-alt", img.alt);
  });

  setSlide(0);
  setPurchase("subscribe");

  const thumbsEl = section.querySelector(".v4-pdp__thumbs");
  if (thumbsEl && !thumbsEl.parentElement?.classList.contains("v4-pdp__thumbs-wrap")) {
    const wrap = document.createElement("div");
    wrap.className = "v4-pdp__thumbs-wrap";
    thumbsEl.parentNode?.insertBefore(wrap, thumbsEl);
    wrap.appendChild(thumbsEl);

    const bar = document.createElement("div");
    bar.className = "v4-pdp__thumbs-bar";
    bar.setAttribute("aria-label", "Scroll product images");
    bar.setAttribute("aria-hidden", "true");
    const barThumb = document.createElement("span");
    barThumb.className = "v4-pdp__thumbs-bar-thumb";
    bar.appendChild(barThumb);
    wrap.appendChild(bar);

    const maxThumbScroll = () => Math.max(0, thumbsEl.scrollWidth - thumbsEl.clientWidth);
    const maxBarTravel = () => Math.max(0, bar.clientWidth - barThumb.offsetWidth);

    const scrollFromBarPos = (thumbLeft) => {
      const travel = maxBarTravel();
      const scrollMax = maxThumbScroll();
      if (travel <= 0 || scrollMax <= 0) return;
      const clamped = Math.min(travel, Math.max(0, thumbLeft));
      thumbsEl.scrollLeft = (clamped / travel) * scrollMax;
    };

    const bindBarDrag = (getClientX) => {
      let dragging = false;

      const onStart = (e) => {
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        dragging = true;
        barThumb.classList.add("--dragging");
        const startX = getClientX(e);
        const startScroll = thumbsEl.scrollLeft;

        const onMove = (moveEvent) => {
          if (!dragging) return;
          const travel = maxBarTravel();
          const scrollMax = maxThumbScroll();
          if (travel <= 0 || scrollMax <= 0) return;
          const dx = getClientX(moveEvent) - startX;
          thumbsEl.scrollLeft = startScroll + (dx / travel) * scrollMax;
        };

        const onEnd = () => {
          dragging = false;
          barThumb.classList.remove("--dragging");
          window.removeEventListener("mousemove", onMove);
          window.removeEventListener("mouseup", onEnd);
          window.removeEventListener("touchmove", onMove);
          window.removeEventListener("touchend", onEnd);
          window.removeEventListener("touchcancel", onEnd);
        };

        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onEnd);
        window.addEventListener("touchmove", onMove, { passive: false });
        window.addEventListener("touchend", onEnd);
        window.addEventListener("touchcancel", onEnd);
      };

      barThumb.addEventListener("mousedown", onStart);
      barThumb.addEventListener(
        "touchstart",
        (e) => {
          if (e.touches.length !== 1) return;
          onStart(e);
        },
        { passive: false }
      );
    };

    bindBarDrag((e) => {
      if ("touches" in e && e.touches.length) return e.touches[0].clientX;
      if ("changedTouches" in e && e.changedTouches.length) return e.changedTouches[0].clientX;
      return e.clientX;
    });

    bar.addEventListener("mousedown", (e) => {
      if (e.button !== 0 || e.target === barThumb) return;
      e.preventDefault();
      const rect = bar.getBoundingClientRect();
      scrollFromBarPos(e.clientX - rect.left - barThumb.offsetWidth / 2);
    });

    bar.addEventListener(
      "touchstart",
      (e) => {
        if (e.target === barThumb || e.touches.length !== 1) return;
        const rect = bar.getBoundingClientRect();
        scrollFromBarPos(e.touches[0].clientX - rect.left - barThumb.offsetWidth / 2);
      },
      { passive: true }
    );

    const syncThumbsBar = () => {
      const overflow = thumbsEl.scrollWidth - thumbsEl.clientWidth > 2;
      wrap.classList.toggle("--scrollable", overflow);
      bar.setAttribute("aria-hidden", overflow ? "false" : "true");

      if (!overflow) return;

      const trackWidth = bar.clientWidth;
      const ratio = thumbsEl.clientWidth / thumbsEl.scrollWidth;
      const thumbWidth = Math.max(36, Math.round(trackWidth * ratio));
      const maxTravel = Math.max(0, trackWidth - thumbWidth);
      const scrollRatio =
        thumbsEl.scrollWidth <= thumbsEl.clientWidth
          ? 0
          : thumbsEl.scrollLeft / (thumbsEl.scrollWidth - thumbsEl.clientWidth);

      barThumb.style.width = `${thumbWidth}px`;
      barThumb.style.transform = `translateX(${Math.round(maxTravel * scrollRatio)}px)`;
    };

    thumbsEl.addEventListener("scroll", syncThumbsBar, { passive: true });
    window.addEventListener("resize", syncThumbsBar);
    if ("ResizeObserver" in window) {
      new ResizeObserver(syncThumbsBar).observe(thumbsEl);
    }
    syncThumbsBar();
  }
})();

/* Hard lock — no horizontal page scroll on product pages (mobile + desktop). */
(function () {
  if (!document.querySelector(".v4-pdp")) return;

  var H_SCROLL =
    ".v4-pdp__thumbs, .v4-pdp__thumbs-wrap, .cross-sells__track, .cross-sells__slider, .cross-sells__scroller, .v4-reviews__scroller, .benefit_marquee_wrap, .fb-def-pairs__grid, [data-fb-pairs-track], [data-h-scroll]";

  function allowed(node) {
    return node && node.closest && node.closest(H_SCROLL);
  }

  function lockX() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft) {
      window.scrollTo(0, y);
      document.documentElement.scrollLeft = 0;
      document.body.scrollLeft = 0;
    }
  }

  lockX();
  window.addEventListener("scroll", lockX, { passive: true });
  window.addEventListener("resize", lockX, { passive: true });
  window.addEventListener("load", lockX);
  window.addEventListener("pageshow", lockX);

  var touchX = 0;
  var touchY = 0;
  var touchInScroll = false;

  document.addEventListener(
    "touchstart",
    function (e) {
      if (e.touches.length !== 1) return;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      touchInScroll = allowed(e.target);
    },
    { passive: true, capture: true },
  );

  document.addEventListener(
    "touchmove",
    function (e) {
      if (e.touches.length !== 1) return;
      if (touchInScroll || allowed(e.target)) return;
      var dx = e.touches[0].clientX - touchX;
      var dy = e.touches[0].clientY - touchY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 4) e.preventDefault();
    },
    { passive: false, capture: true },
  );

  document.addEventListener(
    "touchend",
    function () {
      touchInScroll = false;
    },
    { passive: true, capture: true },
  );
})();
